export const PROJECT_ID_ISLAND_HEALTH = '2068099';
export const PROJECT_ID_ILLINOIS = '2611516';
export const PROJECT_ID_HIGHPOINT = '2084071';
export const PROJECT_ID_AMERI_HEALTH = '2221637';
// export const PROJECT_ID_EXTRA='2221617';